import { render, staticRenderFns } from "./RPReplacementUpdate0.vue?vue&type=template&id=b8a021c2&scoped=true"
import script from "./RPReplacementUpdate0.vue?vue&type=script&lang=js"
export * from "./RPReplacementUpdate0.vue?vue&type=script&lang=js"
import style0 from "./RPReplacementUpdate0.vue?vue&type=style&index=0&id=b8a021c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a021c2",
  null
  
)

export default component.exports